import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import { Link, useLocation } from "react-router-dom";

const BASE_LINKS = [
  {
    section: "Admin",
    links: [
      { txt: "Administrators", href: "admins", icon: "bx-user", superAdminOnly: true },
      { txt: "Roles", href: "roles", icon: "bx-key", superAdminOnly: true },
    ],
  },
  {
    section: "Sales",
    links: [
      // { txt: "Lead Contacts", href: "lead-contacts", icon: "bx-id-card" },
      { txt: "Deal", href: "deals", icon: "bx-task" },
    ],
  },
  {
    section: "Monitor",
    links: [
      { txt: "Leads", href: "leads", icon: "bx-briefcase" },
    ],
  },
  {
    section: "Management",
    links: [
      { txt: "Reports", href: "reports", icon: "bx-briefcase" },
    ],
  },
];

const SidebarContent = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const ref = useRef();

  useEffect(() => {
    const pathName = location.pathname;
    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
    };
    initMenu();
  }, []);

  useEffect(() => {
    ref.current?.recalculate();
  });

  useEffect(() => {
    document.body.classList.remove("sidebar-enable");
  }, [location]);

  const userRole = localStorage.getItem("role");
  const rawPermissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  const allowedResources = rawPermissions.map((p) => p.resource);
  const LINKS = [...BASE_LINKS];
  const hasSales = allowedResources.includes("Sales");
  const hasMonitor = allowedResources.includes("Monitor");
  const contactLinks = [];
  if (hasSales) {
    contactLinks.push(
      { txt: "Status Deals", href: "status-deals", icon: "bx-bar-chart-alt-2" },
      { txt: "Services Deals", href: "services", icon: "bx-cog" },
      { txt: "Status Lead Contacts", href: "statusleadcontacts", icon: "bx-task" }
    );
  }

  if (hasMonitor) {
    contactLinks.push(
      { txt: "Business Categories", href: "business-categories", icon: "bx-archive" },
      { txt: "Lead Source", href: "lead-sources", icon: "bx-chat" },
    );
  }



  if (contactLinks.length > 0) {
    LINKS.push({
      section: "Content",
      links: contactLinks,
    });
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {LINKS.filter((group) => {
              const isSuperAdminSection = group.links.some(link => link.superAdminOnly);
              return (
                (isSuperAdminSection && userRole === "super admin") ||
                allowedResources.includes(group.section) ||
                group.section === "Content"
              );
            }).map((group) => (
              <React.Fragment key={group.section}>
                <li className="menu-title">{t(group.section)}</li>
                {group.links
                  .filter((link) => {
                    if (link.superAdminOnly && userRole !== "super admin") return false;
                    return true;
                  })
                  .map((link) => (
                    <li key={link.txt}>
                      <Link
                        className={
                          (link.children ? "has-arrow " : "") +
                          (location.pathname === "/" + link.href ? " active" : "")
                        }
                        to={link.href ? "/" + link.href : "#"}
                      >
                        {link.icon && <i className={"bx " + link.icon}></i>}
                        <span>{t(link.txt)}</span>
                      </Link>
                      {link.children && (
                        <ul className="sub-menu">
                          {link.children.map((sub) => (
                            <li key={sub.txt}>
                              <Link
                                className={location.pathname.includes(sub.href) ? "active" : ""}
                                to={"/" + sub.href}
                              >
                                {sub.icon && <i className={"bx " + sub.icon}></i>}
                                <span>{t(sub.txt)}</span>
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
              </React.Fragment>
            ))}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

export default SidebarContent;
